import { concatClasses } from "../../../helpers/concatClasses/index.js";
const getTabsStyle = ({ dsf_direction }) => {
  const classes = ["flex", "border-neutral-100", "basis-[fit-content]"];
  if (dsf_direction === "horizontal") {
    classes.push("border-b-1");
  } else {
    classes.push("border-l-1", "grow-0");
  }
  return concatClasses(classes);
};
const getGap = ({ dsf_size }) => {
  switch (dsf_size) {
    case "small":
      return "m";
    case "medium":
      return "l";
    default:
      return "xl";
  }
};
export {
  getGap,
  getTabsStyle
};
